import React, { useEffect, useMemo } from "react";
import SmartifyReport from "../../../components/mailReports/SmartifyReport";

const ReportSmartifyWeekly = () => {
  return <SmartifyReport type="weekly" />;
};

export default ReportSmartifyWeekly;
